import React, { useState, useEffect, useContext } from "react";
import { Link, useParams,useNavigate } from "react-router-dom";
import _ from "lodash";
import { isMobile } from "react-device-detect";
import ServiceStorage from "../../../core/services/service.storage";
import ContextApp from "./../../../core/contexts/context.app";
import ApiRegion from "../../../core/api/api.region";
import ApiAmusementGroup from "../../../core/api/api.amusementGroup";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import TitleH6WithLine from "../../components/TitleH6WithLine";
import SkeletonDetailsContetnt from "../../components/SkeletonComponent/SkeletonDetailsContetnt";
import CardTileH6 from "../../components/CardTileH6";
import SkeletonAmusementGroupTitle from "../../components/SkeletonComponent/SkeletonAmusementGroupTitle";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import LazyLoad from "react-lazyload";

function ListItems(props) {
  const ctx = useContext(ContextApp);
  const [regions, setRegions] = useState([]);
  const { urlParamGroup, urlParamCity } = useParams(); // دریافت پارامتر urlName از روت
  const [loadingAmusementSlider, setLoadingAmusementSlider] = useState(true);
  const [groups, setGroups] = useState();
  const [selectedCity, setSelectedCity] = useState();
  const [pageTitle, setPageTitle] = useState("");
  const [pageContent, setPageContent] = useState("");
  const list = [1, 2, 3, 4, 5, 6];
  const location = useLocation();
  const navigate = useNavigate();
  
  useEffect(() => {
    (async () => {
      window.scrollTo(0, 0);

      const storageCity = ServiceStorage.getCity();
      const cityLis =
        _.has(storageCity, "cityList") && !_.isNil(storageCity.cityList)
          ? JSON.parse(storageCity?.cityList)
          : [];

      let cityListLastUpdateDays = 0;
      let cityListLastUpdate = new Date();
      if (!_.isNil(storageCity?.cityListLastUpdate)) {
        cityListLastUpdate = new Date(storageCity.cityListLastUpdate);
        const now = new Date();
        cityListLastUpdateDays = Math.floor(
          (Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()) -
            Date.UTC(
              cityListLastUpdate.getFullYear(),
              cityListLastUpdate.getMonth(),
              cityListLastUpdate.getDate()
            )) /
          (1000 * 60 * 60 * 24)
        );
      }
      const newUpdateDate =
        cityListLastUpdateDays > 7 ? new Date() : cityListLastUpdate;
      const regoinResult =
        cityLis.length == 0 || cityListLastUpdateDays > 7
          ? await ApiRegion.getRegions()
          : cityLis;
      setRegions(regoinResult);
      const urlSelectedCity = _.find(regoinResult, function (item) {
        return _.lowerCase(item.englishName) === _.lowerCase(urlParamCity);
      });
      console.log("urlSelectedCity",urlSelectedCity);
      // if (_.lowerCase(urlSelectedCity.englishName) != _.lowerCase(urlParamCity))
      if (_.isNil(urlSelectedCity))
        navigate("../PageNotFound");
      setSelectedCity(
        !_.isNil(urlSelectedCity) && !_.isEmpty(urlSelectedCity)
          ? urlSelectedCity
          : ctx.selectedCity
      );
      if (!_.isNil(urlSelectedCity) && _.isObject(urlSelectedCity)) {
        if (urlSelectedCity.selectedCity?.id != ctx?.selectedCity?.id) {
          ctx.setSelectedCity(urlSelectedCity);
        }
      }
      console.log("ServiceStorage urlSelectedCity", !_.isNil(urlSelectedCity)
        ? urlSelectedCity
        : ctx.selectedCity);
      ServiceStorage.setCity({
        cityListLastUpdate: newUpdateDate,
        cityList: regoinResult,
        selectedCity: !_.isNil(urlSelectedCity)
          ? urlSelectedCity
          : ctx.selectedCity,
      });
    })();
  }, []);

  useEffect(() => {
    (async () => {
      if (regions.length > 0) {
        if (!_.isNil(selectedCity) && selectedCity.id != ctx.selectedCity.id) {
          await getAmusements();
          setSelectedCity(ctx.selectedCity);
        } else if (_.isNil(groups)) {
          await getAmusements();
        }

        // if (
        //   !_.isEmpty(selectedCity) &&
        //   _.isEmpty(urlParamGroup)
        // ) {
        //   setPageTitle();
        // }
      }
    })();
  }, [ctx.selectedCity, selectedCity]);
  useEffect(() => {
    (async () => {
      if (regions.length > 0) {
        if (!_.isNil(selectedCity)) {
          await getAmusements();
          setSelectedCity(ctx.selectedCity);
        } else if (_.isNil(groups)) {
          await getAmusements();
        }
        // if (
        //   !_.isEmpty(selectedCity) &&
        //   selectedCity?.id == 899 &&
        //   _.isEmpty(urlParamGroup)
        // ) {
        //   setPageTitle(
        //     "لیست تفریحات کیش با تخفیف ویژه 90 درصدی + مشاوره رایگان - تفریحان"
        //   );
        // }
      }
    })();
  }, [urlParamGroup]);
  const getAmusements = async () => {
    try {
      const response = await ApiAmusementGroup.getAmusementGroups({
        title: urlParamGroup,
        city: ctx.selectedCity.id,
      });
      console.log("response==",response);

      setGroups(response.groups);
      setLoadingAmusementSlider(false);
      console.log("setPageContent response.region.pageTitle ==",response.region.pageTitle );
      setPageContent({
        title: _.isNil(urlParamGroup) ? response.region.pageTitle : response.groups[0].title + " " + response.region.name
        , cityName: response.region.name
        , metaDesc: _.isNil(urlParamGroup) ? response.region.metaDescription : ""
      });
      console.log("setPageContent2 response.region.pageTitle ==",response.region.pageTitle );

    } catch (error) {
      //
      // if (error.response.status == 404) {
      //     history.push("/404");
      //  }
    }
  };

  const handleClick = (value) => { };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // or auto
    });
  };
  return (
    <>
      <div className="wrapper">
        {console.log("pageContent", pageContent)}
        {console.log("!_.isNil(pageContent)", !_.isNil(pageContent) && _.has(pageContent,"title"))}
        {!_.isNil(pageContent) ?
          (<Helmet>
            <link
              rel="canonical"
              href={window.location.origin + location.pathname}
            ></link>
            <meta
              property="og:url"
              content={window.location.origin + location.pathname}
            />
            <title>{pageContent.title}</title>
            <meta property="og:title" content={pageContent.title} />
            <meta
              property="og:description"
              content={pageContent.metaDesc}
            />
            <meta
              name="description"
              content={pageContent.metaDesc}
            />
          </Helmet>) : ""
        }
      </div>
      {console.log("groups", groups)}
      {isMobile ? (
        //******** حالت موبایل**************************
        <Container className="pt-3 px-3 margin-bottom-page" >
          {/* <div className=" bg-light rounded-pill border py-3">
            <Row className="gx-0">
              <Col className="border-end text-center">
                <IconCategory1 fillColor="#404040" /> دسته بندی
              </Col>
              <Col className="text-center">
                <IconFilter fillColor="#404040" /> فیلترکردن
              </Col>
            </Row>
          </div> */}
          {loadingAmusementSlider
            ? list.map((item, index) => (
              <>
                <SkeletonAmusementGroupTitle />
                <Swiper
                  className="amusement-swiper"
                  spaceBetween={15}
                  slidesPerView={"auto"}
                >
                  <SwiperSlide>
                    <SkeletonDetailsContetnt />
                  </SwiperSlide>
                  <SwiperSlide>
                    <SkeletonDetailsContetnt />
                  </SwiperSlide>
                  <SwiperSlide>
                    <SkeletonDetailsContetnt />
                  </SwiperSlide>
                  <SwiperSlide>
                    <SkeletonDetailsContetnt />
                  </SwiperSlide>
                  <SwiperSlide>
                    <SkeletonDetailsContetnt />
                  </SwiperSlide>
                  <SwiperSlide>
                    <SkeletonDetailsContetnt />
                  </SwiperSlide>
                </Swiper>
              </>
            ))
            : groups?.map((groupItem) => (
              <div key={groupItem.id+"_"+groupItem.type}>
                <TitleH6WithLine titleText={groupItem.type==1? groupItem.title + " " + pageContent.cityName:groupItem.title} />
                <Swiper
                  className="amusement-swiper"
                  spaceBetween={15}
                  slidesPerView={"auto"}
                  lazy={true}
                >
                  {groupItem?.amusementServices?.map((amusementService ) => (
                    <SwiperSlide key={amusementService.id}>
                      <CardTileH6
                        itemImgSrc={
                          process.env.REACT_APP_API_URL + amusementService.imageUrl
                        }
                        amusementUrl={`/details/${amusementService.urlName}`}
                        amusementName={amusementService.name}
                        amusementPrice={amusementService.price}
                        amusementFinalPrice={amusementService.originalPrice}
                        handleClick={handleClick}
                        hasReserveDetail_V2={amusementService.hasReserveDetail_V2}
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            ))}

          {!_.isNil(urlParamGroup) && (
            <>
              <Link
                to={
                  ctx.selectedCity?.englishName === undefined
                    ? "/c"
                    : `/c/${ctx.selectedCity?.englishName}`
                }
                className=" w-100 "
              >
                <Button
                  variant="outline-dark "
                  className=" w-100  px-4  mb-5 mt-4 "
                  onClick={scrollToTop}
                >
                  <h3 className="fs-09 text-center mb-0 py-2 ">
                    مشاهده تمام تفریحات{" "}
                  </h3>
                </Button>
              </Link>
            </>
          )}
        </Container>
      ) : //******** حالت دسکتاپ**************************
        loadingAmusementSlider ? (
          list.map((item, index) => (
            <Container key={index} fluid className="bg-light-3">
              <Container className="pb-2">
                <div className=" pt-5 mb-2">
                  <SkeletonAmusementGroupTitle />
                  <Swiper
                    className="amusement-swiper"
                    spaceBetween={15}
                    slidesPerView={"auto"}
                  >
                    <SwiperSlide>
                      <SkeletonDetailsContetnt />
                    </SwiperSlide>
                    <SwiperSlide>
                      <SkeletonDetailsContetnt />
                    </SwiperSlide>
                    <SwiperSlide>
                      <SkeletonDetailsContetnt />
                    </SwiperSlide>
                    <SwiperSlide>
                      <SkeletonDetailsContetnt />
                    </SwiperSlide>
                    <SwiperSlide>
                      <SkeletonDetailsContetnt />
                    </SwiperSlide>
                    <SwiperSlide>
                      <SkeletonDetailsContetnt />
                    </SwiperSlide>
                  </Swiper>
                </div>
              </Container>
            </Container>
          ))
        ) : (
          groups?.map((groupItem) => (
            <Container key={groupItem.id+"_"+groupItem.type} fluid className="bg-light-3">
              <Container className="pb-2">
                <div className="d-flex justify-content-between pt-5 mb-2">
                  <h6 className="text-start fw-bold text-primary fs-101 my-auto">
                  {groupItem.type==1? groupItem.title + " " + pageContent.cityName:groupItem.title}
                  </h6>
                  <hr className="border-bottom" />
                  <div className="my-auto">
                  </div>
                </div>

                <Swiper
                  className="amusement-swiper"
                  spaceBetween={8}
                  slidesPerView={"auto"}
                  lazy={true}
                >
                  {groupItem?.amusementServices?.map((amusementService ) => (
                    <SwiperSlide key={amusementService.id}>
                      <CardTileH6
                        itemImgSrc={process.env.REACT_APP_API_URL + amusementService.imageUrl}
                        amusementUrl={`/details/${amusementService.urlName}`}
                        amusementName={amusementService.name}
                        amusementPrice={amusementService.price}
                        amusementFinalPrice={amusementService.originalPrice}
                        handleClick={handleClick}
                        hasReserveDetail_V2={amusementService.hasReserveDetail_V2}
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </Container>
              <Container className="text-center">
                {!_.isNil(urlParamGroup) && (
                  <>
                    <Link
                      to={
                        ctx.selectedCity?.englishName === undefined
                          ? "/c"
                          : `/c/${ctx.selectedCity?.englishName}`
                      }
                      className=" w-100 "
                    >
                      <Button
                        variant="outline-danger "
                        className=" px-5  mb-5 mt-4 "
                        onClick={scrollToTop}
                      >
                        <h3 className="fs-09 text-center mb-0 py-2 ">
                          مشاهده تمام تفریحات{" "}
                        </h3>
                      </Button>
                    </Link>
                  </>
                )}
              </Container>
            </Container>
          ))
        )}
    </>
  );
}
export default ListItems;
